import { LayoutGraph } from './types';

/**
 * Calculates the maximum width for each level.
 *
 * The width of a level is determined by the widest node in that level.
 */
export function calculateLevelWidths(graph: LayoutGraph, levels: Map<number, number>): Map<number, number> {
    const levelWidths = new Map<number, number>();
    const nodeMap = new Map(graph.nodes.map(node => [node.id, node]));

    // Find max level to ensure all levels (including empty ones) are initialized
    const maxLevel = levels.size > 0 ? Math.max(...levels.values()) : -1;

    // Initialize all levels from 0 to maxLevel with 0 width
    for (let level = 0; level <= maxLevel; level++) {
        levelWidths.set(level, 0);
    }

    // Find max width for each level
    for (const [nodeId, level] of levels.entries()) {
        const node = nodeMap.get(nodeId);
        if (node) {
            const currentWidth = levelWidths.get(level) || 0;
            levelWidths.set(level, Math.max(currentWidth, node.width));
        }
    }

    return levelWidths;
}
